//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
	name: 'PageHeader',

	computed: {
		...mapGetters('vehicle', ['vehicleCount']),
	},
};
